import {
  ServerResolutionResult,
  StringResolutionQuery,
} from 'notebook/tables/string-resolution/StringResolutionConstants';
import * as net from 'util/Net';

export function bulkResolveStringsToValues(resolutionQueries: Array<StringResolutionQuery>): Promise<{
  resolutionResultsWithModels: Array<ServerResolutionResult>;
}> {
  return net.postJSONPromise({
    url: '/1/api/eln:bulk-resolve-strings-to-values',
    data: {resolutionQueries},
  });
}
